import styled from 'styled-components';
import { motion } from 'framer-motion';

interface SectionProps {
  reverse?: boolean;
}

export const Container = styled.div`
  padding-top: 7rem;
  margin-top: 5rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (max-width: 1050px) {
    padding-top: 3rem;
  }
`;

export const Section = styled.div<SectionProps>`
  display: flex;
  flex-direction: ${({ reverse }) => (reverse ? 'row-reverse' : 'row')};
  align-items: center;
  gap: 5rem;
  margin-left: 5rem;
  margin-right: 5rem;
  position: relative;
  
  @media (max-width: 1050px) {
    flex-direction: column-reverse;
    width: 90%;
    margin: 0 auto;
    gap: 3rem;
  }
`;

export const TextContainer = styled(motion.div)`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 3rem;
  @media (max-width: 1050px) {
    
  }
`;

export const ImageContainer = styled(motion.div)`
  flex: 1;
  overflow: hidden; 
  position: relative;
  border-radius: 1.5rem;
  z-index: 1;
  margin-top: -3rem; 
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.4);

  img {
    width: 100%;
    height: 35rem;
    object-fit: cover;
    transition: transform 2.5s ease; /* Smooth transition for the zoom effect */
  }

  img:hover {
    transform: scale(1.1); /* Zoom effect */
  }
  
  @media (max-width: 1050px) {
    margin-top: 0;
    width: 100%;
    img {
      height: 30rem;
    }
  }
`;

export const Paragraph = styled.p`
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 1rem;
`;
